export function createReceiveLineItem(purchaseOrderLineItem, quantity, inboundLocation) {
	return {
		model: purchaseOrderLineItem.model,
		barcode: purchaseOrderLineItem.barcode,
		sku: purchaseOrderLineItem.sku,
		description: purchaseOrderLineItem.description,
		lineTotalCostEx: purchaseOrderLineItem.unitCostEx * quantity,
		lineTotalCostTax: purchaseOrderLineItem.unitCostTax * quantity,
		lineTotalCostInc: purchaseOrderLineItem.unitCostInc * quantity,
		unitCostInc: purchaseOrderLineItem.unitCostInc,
		unitCostEx: purchaseOrderLineItem.unitCostEx,
		unitCostTax: purchaseOrderLineItem.unitCostTax,
		invoicedQuantity: quantity,
		receivedQuantity: quantity,
		quantityAlreadyReceived: 0,
		purchaseOrderItem: purchaseOrderLineItem,
		modifiedDate: new Date().toISOString(),
		inboundLocation,
		originalReceivedQuantity: 0,
		outstandingQuantity: 0,
		damagedQuantity: 0,
		unitDiscountCostInc: 0,
		isDiscounted: false,
		lineDiscountCostInc: 0,
		notes: ''
	};
}
